<template>
  <b-form-group
    :label="label"
    class="medium-label mb-4"
    label-for="files-input">
    <b-form-file
      id="files-input"
      v-model="currentFiles"
      :drop-placeholder="$t('drop-placeholder')"
      :file-name-formatter="filesPlaceholder"
      :multiple=true
      placeholder=""
      tabindex="6"
      v-on:change="emitChangeValue"
      v-on:input="addFiles">
    </b-form-file>
    <template v-for="file in newFilesList">
      <div class="mt-2">
        <b-link @click="downloadNewFile(file)">{{ file.name }}</b-link>
        <trash-icon class="main-red-color trashIcon" size="16" @click="removeNewFile(file)"/>
      </div>
    </template>
    <template v-for="file in oldFilesList">
      <div class="mt-2">
        <b-link @click="downloadOldFile(file)">{{ file.fileName || file.name }}</b-link>
        <trash-icon class="main-red-color trashIcon" size="16" @click="removeOldFile(file)"/>
      </div>
    </template>
  </b-form-group>

</template>

<script>

import api from "../../../services/api";

export default {

  name: "MultiFileField",

  props: {
    label: {
      type: String,
      default: ''
    },
    oldFilesList: {
      type: Array,
      default() {
        return []
      }
    },
    newFilesList: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      currentFiles: []
    }
  },


  emits: ['addFiles', 'removeNewFile', 'removeOldFile', 'didChangeValue'],

  methods: {

    addFiles() {
      this.$emit('addFiles', this.currentFiles)
    },

    removeNewFile(file) {
      this.$emit('removeNewFile', file)
    },

    removeOldFile(file) {
      this.$emit('removeOldFile', file)
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    downloadNewFile(file) {
      let a = document.createElement('a')
      let blob = new Blob([file])
      let url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = file.name
      a.click()
      window.URL.revokeObjectURL(url)
    },

    downloadOldFile(file) {
      if (!file.hasOwnProperty('fileUrl')) {
        this.downloadNewFile(file)
        return
      }
      api({
        method: 'GET',
        url: file.fileUrl,
        responseType: 'blob'
      })
        .then(response => {
          let a = document.createElement('a')
          let blob = new Blob([response.data])
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = file.fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    filesPlaceholder() {
      if (this.newFilesList.length || this.oldFilesList.length) {
        return this.$t('filesSelectedPlaceholder', {count: this.newFilesList.length + this.oldFilesList.length});
      }
      return this.$t('drop-placeholder');
    }
  },

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/MultiFileField.vue